(function () {
  'use strict';

  var PAGE_SIZE = 24;
  function text(value) { return String(value || '').trim(); }

  function friendlyName(value, fallback) {
    var raw = text(value || fallback);
    if (!raw) return '';
    if (raw.indexOf('-') === -1 && raw.indexOf('_') === -1) return raw;
    return raw.replace(/^kids[-_]/i, '').replace(/[-_]+/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function normalize(design, index) {
    var id = text(design.id) || 'D-' + (index + 1);
    var name = friendlyName(design.name, id) || 'Ready design ' + (index + 1);
    return {
      id: id,
      name: name,
      image: text(design.image),
      thumbnail: text(design.thumbnail || design.image),
      image_alt: friendlyName(design.image_alt || design.name, name) || 'Ready bottle design',
      featured: design.featured === true || design.featured === 'true',
      active: design.active !== false && design.active !== 'false',
      sortOrder: Number(design.sortOrder) || index + 1
    };
  }

  function parseDesigns() {
    var node = document.getElementById('designs-data');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return (parsed.designs || []).map(normalize).filter(function (design) { return design.active && design.image; })
        .sort(function (a, b) { return Number(b.featured) - Number(a.featured) || a.sortOrder - b.sortOrder; });
    } catch (error) {
      return [];
    }
  }

  function DesignLibrary(modal, designs) {
    this.modal = modal;
    this.designs = designs;
    this.limit = PAGE_SIZE;
    this.selected = null;
    this.previousFocus = null;
    this.init();
  }

  DesignLibrary.prototype.init = function () {
    var self = this;
    this.grid = this.modal.querySelector('[data-fb-design-grid]');
    this.empty = this.modal.querySelector('[data-fb-design-empty]');
    this.loadMore = this.modal.querySelector('[data-fb-load-more]');
    this.confirm = this.modal.querySelector('#select-design-button');
    this.summary = this.modal.querySelector('[data-fb-modal-summary]');

    document.querySelectorAll('#browseDesignsBtn, [data-fb-open-designs]').forEach(function (button) {
      button.addEventListener('click', function () { self.open(button); });
    });
    this.modal.querySelectorAll('[data-fb-modal-close]').forEach(function (button) {
      button.addEventListener('click', function () { self.close(); });
    });
    this.loadMore.addEventListener('click', function () { self.limit += PAGE_SIZE; self.render(); });
    this.confirm.addEventListener('click', function () {
      if (!self.selected) return;
      document.dispatchEvent(new CustomEvent('fann:design-selected', { detail: self.selected }));
      self.close();
    });
    this.modal.addEventListener('keydown', function (event) { self.onKeydown(event); });
    this.built = false;
  };

  DesignLibrary.prototype.card = function (design) {
    var self = this;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fb-design-card' + (this.selected && this.selected.id === design.id ? ' is-selected' : '');
    button.setAttribute('aria-pressed', this.selected && this.selected.id === design.id ? 'true' : 'false');
    button.setAttribute('aria-label', 'Choose ' + design.name + ', design ' + design.id);

    var media = document.createElement('span');
    media.className = 'fb-design-card__image';
    var image = document.createElement('img');
    image.src = design.thumbnail || design.image;
    image.alt = design.image_alt;
    image.loading = 'eager';
    image.decoding = 'async';
    image.fetchPriority = 'low';
    image.width = 320;
    image.height = 340;
    media.appendChild(image);
    button.appendChild(media);

    if (this.selected && this.selected.id === design.id) {
      var template = document.getElementById('fbDesignCheckTemplate');
      if (template) button.appendChild(template.content.cloneNode(true));
    }
    button.addEventListener('click', function () {
      self.selected = design;
      self.updateSummary();
      self.render();
    });
    return button;
  };

  DesignLibrary.prototype.render = function () {
    var self = this;
    var items = this.designs;
    this.grid.replaceChildren();
    items.slice(0, this.limit).forEach(function (design) { self.grid.appendChild(self.card(design)); });
    this.empty.hidden = items.length !== 0;
    this.loadMore.hidden = items.length <= this.limit;
  };

  DesignLibrary.prototype.updateSummary = function () {
    this.confirm.disabled = !this.selected;
    this.summary.hidden = !this.selected;
    if (!this.selected) return;
    var image = this.summary.querySelector('[data-fb-modal-summary-image]');
    image.src = this.selected.thumbnail || this.selected.image;
    image.alt = this.selected.image_alt;
    this.summary.querySelector('[data-fb-modal-summary-name]').textContent = this.selected.name;
    this.summary.querySelector('[data-fb-modal-summary-code]').textContent = 'Design ' + this.selected.id;
  };

  DesignLibrary.prototype.open = function (button) {
    this.previousFocus = button || document.activeElement;
    if (!this.built) {
      this.render();
      this.built = true;
    }
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fb-design-modal-open');
    window.setTimeout(function () {
      var firstDesign = this.grid.querySelector('.fb-design-card');
      (firstDesign || this.modal.querySelector('[data-fb-modal-close]')).focus();
    }.bind(this), 20);
  };

  DesignLibrary.prototype.close = function () {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fb-design-modal-open');
    if (this.previousFocus) this.previousFocus.focus();
  };

  DesignLibrary.prototype.onKeydown = function (event) {
    if (event.key === 'Escape') { this.close(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(this.modal.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  function init() {
    var modal = document.getElementById('design-selection-modal');
    if (!modal || modal.dataset.fbInitialized) return;
    modal.dataset.fbInitialized = 'true';
    new DesignLibrary(modal, parseDesigns());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
